<template>
  <v-row justify="center" align="center">
    <v-col cols="12" md="6" lg="5">
      <div v-if="loading" class="text-center my-6">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        <p class="mt-3">{{ messages.Loading }}</p>
      </div>

      <div v-else-if="!payData">
        <v-alert type="error" prominent>
          {{ errorMessage }}
        </v-alert>
        <div class="text-center" v-if="returnUrl">
          <v-btn color="primary" rounded @click="goBack">{{ messages.BackButton || "Back to Student Portal" }}</v-btn>
        </div>
      </div>

      <v-card v-else class="elevation-4">
        <v-toolbar dense color="secondary" dark>{{ messages.PayNowTitle }}</v-toolbar>
        <v-card-text>
          <p>{{ messages.PayNowInfo }}</p>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr>
                  <th>Name</th>
                  <td>: {{ payData.firstName }} {{ payData.lastName }}</td>
                </tr>
                <tr>
                  <th>Phone No</th>
                  <td>: {{ payData.phone }}</td>
                </tr>
                <tr>
                  <th>Email</th>
                  <td>: {{ payData.email }}</td>
                </tr>
                <tr>
                  <th>TXN ID</th>
                  <td>: {{ payData.txnID }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-data-table
            :mobile-breakpoint="mobilebreakpoint"
            :headers="headers"
            :items="payData.payDatas"
            :hide-default-footer="true"
            :items-per-page="-1"
            item-key="installmentDate"
            class="elevation-2 mt-2"
          >
            <template v-slot:item.amount="{ item }">
              <span>{{ formatNumber(item.amount) }}</span>
            </template>
            <template v-slot:item.installmentDate="{ item }">
              <span>{{ formatDate(item.installmentDate, "DD-MMM-YY") }}</span>
            </template>
            <template slot="body.append">
              <td class="py-3 font-weight-black total">
                <span>Total</span>
              </td>
              <td class="py-3 font-weight-black total">
                {{ formatNumber(payData.amount) }}
              </td>
            </template>
          </v-data-table>

          <form :action="payData.payUUrl" method="post" @submit="paying = true">
            <input type="hidden" name="firstname" :value="payData.firstName" />
            <input type="hidden" name="lastname" :value="payData.lastName" />
            <input type="hidden" name="surl" :value="payData.surl" />
            <input type="hidden" name="phone" :value="payData.phone" />
            <input type="hidden" name="key" :value="payData.key" />
            <input type="hidden" name="hash" :value="payData.hashData" />
            <input type="hidden" name="curl" :value="payData.curl" />
            <input type="hidden" name="furl" :value="payData.furl" />
            <input type="hidden" name="txnid" :value="payData.txnID" />
            <input type="hidden" name="productinfo" :value="payData.productInfo" />
            <input type="hidden" name="amount" :value="payData.strAmount" />
            <input type="hidden" name="email" :value="payData.email" />

            <v-btn class="my-3" type="submit" color="primary" block rounded x-large :loading="paying" :disabled="paying">
              <v-icon> mdi-credit-card-outline </v-icon>
              &nbsp;{{ messages.PayNowButton }} {{ formatNumber(payData.amount) }}
            </v-btn>
          </form>
          <v-btn v-if="returnUrl" block text rounded color="grey darken-1" :disabled="paying" @click="goBack">
            {{ messages.PayNowCancel || "Cancel and go back to Student Portal" }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<style scoped>
.total {
  background-color: lightgray;
  text-align: right;
  padding-right: 1em;
}
</style>
<script>
import axios from "axios";
import { get } from "vuex-pathify";
import { formatDate, formatNumber } from "../util/helpers";

export default {
  name: "PayNow",

  data: () => ({
    loading: true,
    paying: false,
    payData: null,
    messages: {},
    errorMessage: "",
    returnUrl: "",
    mobilebreakpoint: "200",
    headers: [
      {
        text: "Installment Date",
        value: "installmentDate",
        width: "120px",
        sortable: false,
      },
      {
        text: "Amount",
        value: "amount",
        width: "150px",
        align: "right",
        sortable: false,
      },
    ],
  }),
  computed: {
    apiUrl: get("app/apiUrl"),
  },
  watch: {
    // config.json is read in App.vue; wait for the API url before loading.
    apiUrl: function (value) {
      if (value) this.showData();
    },
  },
  mounted() {
    if (this.apiUrl) this.showData();
  },
  methods: {
    formatNumber,
    formatDate,

    goBack() {
      window.location.href = this.returnUrl;
    },

    showData() {
      const self = this;
      self.loading = true;

      axios({
        url: self.apiUrl + "api/Fees/PayGate/" + encodeURIComponent(self.$route.params["txnid"]),
        method: "GET",
        params: { exp: self.$route.query.exp, sig: self.$route.query.sig },
        responseType: "json",
      })
        .then(function (res) {
          self.messages = res.data.messages || {};
          self.returnUrl = res.data.returnUrl;
          if (res.data.ok) {
            self.payData = res.data;
          } else if (res.data.statusUrl) {
            self.$router.replace(res.data.statusUrl);
            return;
          } else {
            self.errorMessage = res.data.message;
          }
          self.loading = false;
        })
        .catch(function () {
          self.errorMessage = self.messages.LinkInvalid || "Unable to load payment details. Please try again later.";
          self.loading = false;
        });
    },
  },
};
</script>
